(function () {
  'use strict';

  function initFirmengeschichte() {
    document.querySelectorAll('.fmg-entry').forEach(function (entry) {
      var btn = entry.querySelector('.fmg-pkg-btn');
      var svg = entry.querySelector('.fmg-pkg-svg');
      var wrap = entry.querySelector('.fmg-story-wrap');
      if (!btn) return;

      btn.addEventListener('click', function () {
        var isOpen = entry.classList.contains('is-open');

        if (isOpen) {
          entry.classList.remove('is-open');
          svg.classList.remove('is-open');
          wrap.setAttribute('aria-hidden', 'true');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          entry.classList.add('is-open');
          svg.classList.remove('is-open');
          // Trigger reflow so animation replays
          void svg.offsetWidth;
          svg.classList.add('is-open');
          wrap.setAttribute('aria-hidden', 'false');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFirmengeschichte);
  } else {
    initFirmengeschichte();
  }

  // Shopify Theme Editor: re-init on section reload
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.fmg-section')) {
      initFirmengeschichte();
    }
  });
})();
